module.exports = __webpack_public_path__ + "img/face-smile-tear.8e84a387.svg";